import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Plus, Image as ImageIcon } from 'lucide-react';

const GaleriSection = () => {
  const { t } = useLanguage();

  const [images] = useState([
    { id: 1, src: '/galeri/galeri-1.jpg', alt: 'Galeri 1' },
    { id: 2, src: '/galeri/galeri-2.jpg', alt: 'Galeri 2' },
    { id: 3, src: '/galeri/galeri-3.jpg', alt: 'Galeri 3' },
    { id: 4, src: '/galeri/galeri-4.jpg', alt: 'Galeri 4' },
    { id: 5, src: '/galeri/galeri-5.jpg', alt: 'Galeri 5' },
    { id: 6, src: '/galeri/galeri-6.jpg', alt: 'Galeri 6' },
    { id: 7, src: '/galeri/galeri-7.jpg', alt: 'Galeri 7' },
    { id: 8, src: '/galeri/galeri-8.jpg', alt: 'Galeri 8' },
    { id: 9, src: '/galeri/galeri-9.jpg', alt: 'Galeri 9' },
    { id: 10, src: '/galeri/galeri-10.jpg', alt: 'Galeri 10' },
    { id: 11, src: '/galeri/galeri-11.jpg', alt: 'Galeri 11' },
    { id: 12, src: '/galeri/galeri-12.jpg', alt: 'Galeri 12' },
    { id: 13, src: '/galeri/galeri-13.jpg', alt: 'Galeri 13' },
    { id: 14, src: '/galeri/galeri-14.jpg', alt: 'Galeri 14' },
    { id: 15, src: '/galeri/galeri-15.jpg', alt: 'Galeri 15' },
    { id: 16, src: '/galeri/galeri-16.jpg', alt: 'Galeri 16' },
    { id: 17, src: '/galeri/galeri-17.jpg', alt: 'Galeri 17' },
    { id: 18, src: '/galeri/galeri-18.jpg', alt: 'Galeri 18' },
    { id: 19, src: '/galeri/galeri-19.jpg', alt: 'Galeri 19' },
    { id: 20, src: '/galeri/galeri-20.jpg', alt: 'Galeri 20' },
    { id: 21, src: '/galeri/galeri-21.jpg', alt: 'Galeri 21' },
    { id: 22, src: '/galeri/galeri-22.jpg', alt: 'Galeri 22' },
    { id: 23, src: '/galeri/galeri-23.jpg', alt: 'Galeri 23' },
    { id: 24, src: '/galeri/galeri-24.jpg', alt: 'Galeri 24' },
  ]);

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="galeri" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t('gallery.title')}
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto"></div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((image) => (
            <Card
              key={image.id}
              className="border-none shadow-md hover:shadow-xl transition-all cursor-pointer group overflow-hidden"
              onClick={() => setSelectedImage(image)}
            >
              <CardContent className="p-0">
                <div className="aspect-square bg-gray-100 relative overflow-hidden">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-amber-500/0 group-hover:bg-amber-500/20 transition-colors flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center">
                        <Plus className="w-5 h-5 text-amber-600" />
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Lightbox Dialog */}
        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent className="max-w-4xl p-0 overflow-hidden">
            <DialogHeader className="p-4 border-b">
              <DialogTitle>{selectedImage?.alt}</DialogTitle>
            </DialogHeader>
            {selectedImage && (
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-auto"
              />
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default GaleriSection;